import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../@core/services/auth.service';
import { USM_USR_35 } from '../../../@shared/models/input.module';
import { LoginResponse } from '../../../@shared/models/response.module';

@Component({
  selector: 'app-verify-email',
  standalone: false,
  templateUrl: './verify-email.html',
  styleUrl: './verify-email.css'
})
export class VerifyEmail implements OnInit {
  verificationStatus: 'verifying' | 'success' | 'error' = 'verifying';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const verificationToken = params['verification_token'];

      if (!verificationToken) {
        this.verificationStatus = 'error';
        this.errorMessage = 'No verification token provided';
        return;
      }

      const payload: USM_USR_35 = {
        verification_token: verificationToken
      };

      this.authService.verifyEmail(payload).subscribe(
        (response: LoginResponse) => {
          this.verificationStatus = 'success';

          // Store authentication data
          this.authService.setAuth(response);

          // Redirect to home after 2 seconds
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 2000);
        },
        (error) => {
          this.verificationStatus = 'error';
          this.errorMessage = error?.error?.message || 'Verification failed. The link may have expired or is invalid.';
        }
      );
    });
  }

  navigateToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
